/**
 * kuchikomi
 */

(function() {
  // brand anchorlink list
  var kuchikomiBrandAnchorList = '.js-kuchikomi-brand-anchor-list';

  // 口コミindexページのみで実行
  $(kuchikomiBrandAnchorList).slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
  });
}());

$(function() {
  // anchor scroll
  var $anchor = $('.js-kuchikomi-anchor-link');

  $anchor.on('click', function() {
    var speed = 300,
        href= $(this).attr('href'),
        target = $(href == '#' || href == '' ? 'body' : href),
        position = target.offset().top;

    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  // slider controll
  var $pageKuchikomiIndex = $('.page_kuchikomi_index'),
      $pageKuchikomiBrand = $('.page_kuchikomi_brand'),
      time = 1500;

  var nameSpaceHeight = function(height) {
    var brandNameHeight = $('.js-kuchikomi-brand-list-item-name').height(),
        $slickArrow = $('.slick-arrow');

    var $listItem = $('.js-list-item'),
        items = $listItem.length,
        $slickList = $('.slick-list');

    // 個社名が3行以上の場合、PREV&NEXTボタンの高さを変更させる
    if(brandNameHeight == 48) {
      $slickArrow.css('height', height + 'px');
    }
    // よく比較される動画配信サービスの件数が少ない場合、paddingを変更させる
    if((items / 2) <= 4) {
      $slickList.addClass('slick-list--low-item');
    }
  };

  if($pageKuchikomiBrand.length > 0) {
    setTimeout(nameSpaceHeight.bind(undefined, '195'), time);
  }

  // bar graph
  var $barGraph = $('.js-bar-graph'),
      $score = $('.js-score'),
      data, denominator;

  // 母数計算
  var barGraphSum = function(arr) {
    return arr.reduce(function(prev, current) {
      return prev + current;
    });
  }

  // 高さのパーセンテージ計算
  var barHeight = function(score, denominator) {
    return Math.round(score / denominator * 100);
  }

  $barGraph.on('inview', function(event, isInView) {
    // グラフエリアが表示領域に全て入った時点で実行
    if(isInView) {
      // グラフデータ（順序を反転させている）
      data = JSON.parse($(this).attr('data-scores')).slice().reverse();
      // 母数計算
      denominator = barGraphSum(data);

      $(this).children().each(function(i) {
        var height = barHeight(data[i], denominator);
        $(this).children().height(height + '%');
      });
    }
  });
});